import React from "react";
import { Col, Glyphicon } from "react-bootstrap";

const AnalyticWidget = ({ icon, value, label }) => (
  <Col sm={3}>
    <div className="hero-widget well well-sm">
      <div className="icon">
        <Glyphicon glyph={icon} />
      </div>
      <div className="text">
        <var>
          {!value
            ? "-"
            : Intl.NumberFormat("de-DE", { maximumFractionDigits: 2 }).format(
                value,
              )}
        </var>
        <label className="text-muted">{label}</label>
      </div>
    </div>
  </Col>
);

export default AnalyticWidget;
